import CalendarMobile from '@/components/reusable/searchDatePicker/calendarMobile/CalendarMobile';
import Box from '@/components/UI/box/Box';
import Button from '@/components/UI/button/Button';
import styles from './CalendarModal.module.scss';
import { useSelector } from 'react-redux';
import DatePickerDescription from '@/components/houses/_reusable/datePickerDescription/DatePickerDescription';
const CalendarModal = ({
  open,
  onClose,
  handleDatePickerChange,
  calendarRef,
  onSubmit,
  minDays
}) => {
  const {
    checkout
  } = useSelector(state => state.basicFilters);
  return <CalendarMobile open={open} onClose={onClose} handleDatePickerChange={handleDatePickerChange} calendarRef={calendarRef} isFull={false} backIcon minDays={minDays} headerChildren={<Box className={styles['calendare-header-container']}>
          <DatePickerDescription />
        </Box>} footer={<Box className={styles['midterm-date-button']}>
          <Button className={styles['submit-date-button']} format="primary" onClick={onSubmit} disabled={!checkout}>
            تایید
          </Button>
        </Box>} data-sentry-element="CalendarMobile" data-sentry-component="CalendarModal" data-sentry-source-file="CalendarModal.tsx" />;
};
export default CalendarModal;